import { Component } from '@angular/core';

@Component({
  selector: 'baoying-app-root',
  templateUrl: './baoying-app.component.html',
})
export class BaoyingAppComponent {
  title = 'baoying';
}
